import { SportCard } from './types';

export const sportsData: SportCard[] = [
  {
    id: 'Pickleball',
    name: 'Pickleball',
    image: '',
    description: 'Fast-paced racquet sport with precision and agility',
    color: 'from-green-500 to-emerald-600',
    backgroundImage: '/pickel-ball.jpg',
    features: ['Indoor Courts', 'Professional Flooring', 'Shuttlecocks Included', 'Tournament Hosting'],
    venues: '200+',
    players: '6K+',
    rating: 4.6
  },
  {
    id: 'badminton',
    name: 'Badminton',
    image: '🏸',
    description: 'Fast-paced racquet sport with precision and agility',
    color: 'from-green-500 to-emerald-600',
    backgroundImage: 'https://images.pexels.com/photos/2202685/pexels-photo-2202685.jpeg',
    features: ['Indoor Courts', 'Professional Flooring', 'Shuttlecocks Included', 'Tournament Hosting'],
    venues: '200+',
    players: '6K+',
    rating: 4.6
  },
  {
    id: 'cricket',
    name: 'Box Cricket',
    image: '🏏',
    description: 'Indoor cricket experience with all the excitement',
    color: 'from-orange-500 to-red-600',
    backgroundImage: 'https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    features: ['Indoor Pitches', 'Soft Ball', 'Equipment Provided', 'Team Tournaments'],
    venues: '150+',
    players: '4.5K+',
    rating: 4.7
  },
  {
    id: 'padel',
    name: 'Padel',
    image: '🎾',
    description: 'Exciting racquet sport combining tennis and squash',
    color: 'from-blue-500 to-cyan-600',
    backgroundImage: 'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    features: ['Glass Courts', 'Professional Equipment', 'Coaching Available', 'Doubles Play'],
    venues: '80+',
    players: '2.5K+',
    rating: 4.8
  },
  {
    id: 'football',
    name: 'Football',
    image: '⚽',
    description: 'The beautiful game on premium turf fields',
    color: 'from-purple-500 to-pink-600',
    backgroundImage: 'https://images.pexels.com/photos/102448/pexels-photo-102448.jpeg',
    features: ['Professional Turf', 'Floodlights', 'Changing Rooms', 'Equipment Rental'],
    venues: '180+',
    players: '8K+',
    rating: 4.9
  },
  {
    id: 'pickleball',
    name: 'Pickleball',
    image: '🏓',
    description: 'Fun paddle sport thats easy to learn and addictive',
    color: 'from-pink-500 to-rose-600',
    backgroundImage: 'https://images.pexels.com/photos/5740518/pexels-photo-5740518.jpeg',
    features: ['Outdoor Courts', 'Paddle Rental', 'Beginner Classes', 'Tournament Play'],
    venues: '120+',
    players: '3.5K+',
    rating: 4.5
  },
  {
    id: 'volleyball',
    name: 'Volleyball',
    image: '🏐',
    description: 'Team sport excitement with beach and indoor options',
    color: 'from-yellow-500 to-orange-600',
    backgroundImage: 'https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    features: ['Beach & Indoor', 'Professional Nets', 'Team Building', 'League Play'],
    venues: '90+',
    players: '4K+',
    rating: 4.6
  }
]; 